import { InvalidTransactionTypeError } from '../../errors';
export var TransactionTypeModel;
(function (TransactionTypeModel) {
    TransactionTypeModel[TransactionTypeModel["Miner"] = 0] = "Miner";
    TransactionTypeModel[TransactionTypeModel["Issue"] = 1] = "Issue";
    TransactionTypeModel[TransactionTypeModel["Claim"] = 2] = "Claim";
    TransactionTypeModel[TransactionTypeModel["Enrollment"] = 32] = "Enrollment";
    TransactionTypeModel[TransactionTypeModel["Register"] = 64] = "Register";
    TransactionTypeModel[TransactionTypeModel["Contract"] = 128] = "Contract";
    TransactionTypeModel[TransactionTypeModel["State"] = 144] = "State";
    TransactionTypeModel[TransactionTypeModel["Publish"] = 208] = "Publish";
    TransactionTypeModel[TransactionTypeModel["Invocation"] = 209] = "Invocation";
})(TransactionTypeModel || (TransactionTypeModel = {}));
const isTransactionType = (value) => TransactionTypeModel[value] !== undefined;
export const assertTransactionType = (value) => {
    if (isTransactionType(value)) {
        return value;
    }
    throw new InvalidTransactionTypeError(value);
};

//# sourceMappingURL=TransactionTypeModel.js.map
